<template>
    <Card>
        <template v-slot:title>
            Simulate Select Driver
        </template>

        <div class="d-flex flex-column gap-2">
            <div>
                <div class="font-size-lg font-weight-bold">
                    {{ data.order.id }}
                </div>
                <div>
                    <div>Channel: {{ data.order.sales_channel.name }}</div>
                    <div>Order-ID: {{ data.order.sales_channel.order_id }}</div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-6">
                    <div class="font-weight-bold font-size-lg">
                        Start address:
                    </div>
                    <KVTable :data="data.order.store_address"/>
                </div>
                <div class="col-md-6">
                    <div class="font-weight-bold font-size-lg">
                        Delivery target:
                    </div>
                    <KVTable :data="data.order.delivery_address"/>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-3">
                    <div class="font-weight-bold font-size-lg">
                        Package Preset IDs:
                    </div>
                    <div>
                        {{ packageIds.sort().join(', ') }}
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="font-weight-bold font-size-lg">
                        Package Count By ID:
                    </div>
                    <KVTable class="w-50 text-monospace"
                             :data="packageCountById"
                             keyClass="font-weight-bold"
                             :valueTransformer="value => 'x'+value"
                    />
                </div>
                <div class="col-md-3">
                    <div class="font-weight-bold font-size-lg">
                        Kühlung:
                    </div>
                    <div>
                        <div v-for="coolingLevelId in GarantiertGeliefertCoolingLevel">
                            <i v-if="coolingLevelId === coolingLevel" class="fas fa-check-circle text-primary"/>
                            <i v-else class="fas  fa-circle opacity-25"/>
                            <span>{{ __('integrations.gg.cooling.' + coolingLevelId) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <button class="btn btn-success" @click="driverFound">
                <i class="fas fa-check"/>
                Driver found
            </button>
            <button class="btn btn-danger" @click="driverUnavailable">
                <i class="fas fa-times"/>
                Driver unavailable
            </button>
        </div>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import axios from "axios";
import {GarantiertGeliefertCoolingLevel} from "@generated/garantiertGeliefertCoolingLevel";
import KVTable from "@components/KVTable.vue";

export default {
    components: {KVTable, Card},

    props: {
        data: Object,
        coolingLevel: Number,
        packageIds: Array,
        packageCountById: Array,
    },

    methods: {
        driverFound() {
            axios.post(this.$route('GG.simulate'), {
                target_data: this.data.submit_carrier_info
            }).then((onSuccess) => {
                close();
            }, (error) => {
                toastr.warning('Etwas ist schiefgegangen, bitte versuchen Sie es erneut.');
            })
        },

        driverUnavailable() {
            close();
        }
    },

    computed: {
        GarantiertGeliefertCoolingLevel() {
            return GarantiertGeliefertCoolingLevel
        }
    },
}
</script>
